//@flow
import {useState} from 'react';
import {deleteStoreContactService, createStoreContactService} from './promises';

import {actions} from '../../information/duck';
import {useActions} from '../../../utils/globalStore';

import type {SaveGeneralContactRequest} from './api';

export function useStoreContacts() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchStoreContact = useActions(actions.fetchStoreContact);

  const deleteStoreContact = async (storeContactId: string) => {
    setLoading(true);
    try {
      await deleteStoreContactService(storeContactId);
      fetchStoreContact();
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const createStoreContact = async (contact: SaveGeneralContactRequest) => {
    setLoading(true);
    try {
      await createStoreContactService(contact);
      fetchStoreContact();
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return {
    deleteStoreContact,
    createStoreContact,
    loading,
    error,
  };
}
